<template>
  <main>
    <section-hero :bgImg="bgImg" :subtitle="subtitle"></section-hero>
    <section-science-slider id="scrollToOnLoad"></section-science-slider>
    <section-resources></section-resources>
    <section-support></section-support>
  </main>
</template>

<script>
import Hero from '@/components/Hero';
import ScienceSlider from '@/views/ScienceInSchool/ScienceSlider';
import Resources from '@/views/ScienceInSchool/Resources';
import Support from '@/components/Support/Index';

export default {
  data() {
    return {
      bgImg: 'Banner1-I_Love_Science-',
      subtitle: this.$t('nav.iLoveScience'),
    };
  },
  components: {
    'section-hero': Hero,
    'section-science-slider': ScienceSlider,
    'section-resources': Resources,
    'section-support': Support,
  },
};
</script>

<style lang="scss" scoped>
@import "./src/styles/helpers/_variables.scss";
</style>



// WEBPACK FOOTER //
// src/views/ScienceInSchool/Index.vue